<template>
  <div class="lib-radio-select">
    <div v-for="(option, index) in options" class="radio">
      <input
          class="input-radio"
          type="radio"
          :id="`option_${name}_${index}`"
          :name="name"
          @input="select(option)"
          :checked="options.indexOf(option) === value"
          :value="option.description"><label :for="`option_${name}_${index}`" class="radio-label">{{ option.description }}</label>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LibRadioSelect',
  props: ['name', 'options', 'value'],
  emits: ['update:modelValue'],
  data() {
    return {
    };
  },
  methods: {
    select(value) {
      let index = this.options.indexOf(value);
      this.$emit('input', index);
    },
  },
  computed: {
    display() {
      return this.options[this.value].description;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../src/scss/prelude";

.lib-radio-select {
  margin: 0.0rem;

  input[type="radio"] {
    margin-right: 10px;
    cursor: pointer;
  }

  & label {
    cursor: pointer;
  }

  & > .radio:not(:last-child) {
    margin-bottom: 20px;
  }
}
</style>